import SetPasswordContainer from './SetPasswordContainer.js';
export default SetPasswordContainer;